export default {"src":"/_next/static/media/voice.9ee1c7f9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};